import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AuthConfig } from '@auth/auth-config';
import { PasswordValidatorOptions } from 'src/app/@shared/password.validator';

@Injectable({
  providedIn: 'root',
})
export class PasswordValidationService {
  private translate = inject(TranslateService);

  // eslint-disable-next-line max-lines-per-function
  public getDefaultOptions(): PasswordValidatorOptions {
    return {
      minLength: {
        order: 0,
        text: this.translate.instant('FORM.INPUT.PASSWORD.VALIDATION.MIN_LENGTH',
          {
            count: AuthConfig.password.minLength,
          }),
        value: AuthConfig.password.minLength,
      },
      minLowerCase: {
        order: 1,
        text: this.translate.instant(`FORM.INPUT.PASSWORD.VALIDATION.${this.getTranslateKey('MIN_LOWER_CASE',
          AuthConfig.password.minLowerCase)}`,
        {
          count: AuthConfig.password.minLowerCase,
        }),
        value: AuthConfig.password.minLowerCase,
      },
      minNumbers: {
        order: 3,
        text: this.translate.instant(`FORM.INPUT.PASSWORD.VALIDATION.${this.getTranslateKey('MIN_NUMBERS',
          AuthConfig.password.minNumbers)}`,
        {
          count: AuthConfig.password.minNumbers,
        }),
        value: AuthConfig.password.minNumbers,
      },
      minSpecial: {
        order: 4,
        text: this.translate.instant(`FORM.INPUT.PASSWORD.VALIDATION.${this.getTranslateKey('MIN_SPECIAL',
          AuthConfig.password.minSpecial)}`,
        {
          count: AuthConfig.password.minSpecial,
        }),
        value: AuthConfig.password.minSpecial,
      },
      minUpperCase: {
        order: 2,
        text: this.translate.instant(`FORM.PASSWORD.VALIDATION.${this.getTranslateKey('MIN_UPPER_CASE',
          AuthConfig.password.minUpperCase)}`,
        {
          count: AuthConfig.password.minUpperCase,
        }),
        value: AuthConfig.password.minUpperCase,
      },
    };
  }

  // based on count value return singular or plural form
  private getTranslateKey(key: string, count: number): string {
    if (count !== 1) {
      return `${key}_PLURAL`;
    }

    return key;
  }
}
